import { GetterTree } from 'vuex'
import { DevicePowerState } from './types'
import { RootState } from '../types'

export const getters: GetterTree<DevicePowerState, RootState> = {
}
